import { FC, InputHTMLAttributes } from 'react'
import cn from 'classnames'
import styles from 'components/atoms/inputs/PlainSelectInput/PlainSelectInput.styl'

type PlainSelectInputProps =
  & InputHTMLAttributes<HTMLInputElement>
  & {
    innerRef?: (instance: HTMLInputElement) => void
    isOpen?: boolean
  }
export const PlainSelectInput: FC<PlainSelectInputProps> = (props) => {
  const { innerRef, isOpen, ...restProps } = props
  return (
    <div className={ cn(styles.plainSelectInput, isOpen && styles.isOpen) }>
      <input
        autoComplete='new-password' // Prevents autocompletion better than 'off'
        data-lpignore='true' // Prevent LastPass from treating field
        ref={ innerRef }
        { ...restProps }
      />
    </div>
  )
}
